<template>
  <div class="container">
    <!--第一屏-->
    <section
      v-show="banner.banner_img"
      id="banner-home"
      class="banner relative"
      :style="{
        backgroundImage:
          'url(' +
          (isMobileImg ? banner.banner_img + mobileImgQ : banner.banner_img) +
          ')',
      }"
    >
      <div class="banner-text">
        <h1 class="title">众多用户的共同选择</h1>
        <p class="description description-letter">帮你高效减脂塑形，提升气质，更健康活力</p>
      </div>
      <ul class="download">
        <li class="download-hover">
          <div class="erweima ios hide-m">
            <img
              src="//qiniucdn.dailyyoga.com.cn/d6/2b/d62bbb7a3c2db86f29b469a20ff49b5e.png"
              alt="每日瑜伽专业瑜伽教学平台"
            />
          </div>
          <a
            @click="qrCode('iOS')"
            class="pull-left download-new ios-download"
            href="javascript:;"
          ></a>
        </li>

        <li class="download-hover">
          <div class="erweima and hide-m">
            <img
              src="//qiniucdn.dailyyoga.com.cn/d6/2b/d62bbb7a3c2db86f29b469a20ff49b5e.png"
              alt="每日瑜伽专业瑜伽教学平台"
            />
          </div>
          <a
            @click="qrCode('And')"
            class="pull-left download-new ad-download"
            href="javascript:;"
          ></a>
        </li>

        <li>
          <a
            class="pull-left download-new tv-download hide-m"
            style="width: 150px; box-sizing: border-box"
            href="//qiniuapk.dailyyoga.com.cn/Yoga_TV_300000.apk"
          ></a>
        </li>
      </ul>
      <!--下载报告-->
      <!--       <div class="download-report">
        <em>每日瑜伽联合艾瑞发布</em>
        <a href="http://report.iresearch.cn/report_pdf.aspx?id=3260" target="_blank">
          <span>2018中国瑜伽行业研究报告</span>
          <a>点击查看 ></a>
        </a>
      </div> -->
    </section>

    <!--第二屏幕-->
    <section class="section home-part5" style="margin: 0;">
      <div class="clearfix">
        <img
            id="videoHomeCover"
            v-lazy="
              isMobileImg
                ? 'https://qiniucdn.dailyyoga.com.cn/c60db86686bfbd2b92d8a6bf27ab18efxayl.png' +
                  mobileImgQ
                : 'https://qiniucdn.dailyyoga.com.cn/c60db86686bfbd2b92d8a6bf27ab18efxayl.png'
            "
            alt="每日瑜伽专业瑜伽教学平台"
          />
      </div>
    </section>

    <!--第三屏幕-->
    <section class="section home-part5" style="margin: 0;">
      <div class="clearfix">
          <img
            src
            v-lazy="
              isMobileImg
                ? 'https://qiniucdn.dailyyoga.com.cn/9cc905b5c6f7a4d81d52655624c01d68xayl.png' +
                  mobileImgQ
                : 'https://qiniucdn.dailyyoga.com.cn/9cc905b5c6f7a4d81d52655624c01d68xayl.png'
            "
            alt="每日瑜伽专业瑜伽教学平台"
          />
      </div>
    </section>

    <!--第四屏幕-->
    <section class="section home-part5" style="margin: 0;">
      <div class="clearfix">
          <img
            src
            v-lazy="
              isMobileImg
                ? 'https://qiniucdn.dailyyoga.com.cn/6b2820e5bba3d1d72d61ff0bd9b74aeaxayl.png' +
                  mobileImgQ
                : 'https://qiniucdn.dailyyoga.com.cn/6b2820e5bba3d1d72d61ff0bd9b74aeaxayl.png'
            "
            alt="每日瑜伽专业瑜伽教学平台"
          />
      </div>
    </section>

    <!--第五屏幕-->
    <section class="section home-part5" style="margin: 0;">
      <div class="clearfix">
          <img
            src
            v-lazy="
              isMobileImg
                ? 'https://qiniucdn.dailyyoga.com.cn/a4ecc7f58f59e91d77a018d5d7ae42e2xayl.png' +
                  mobileImgQ
                : 'https://qiniucdn.dailyyoga.com.cn/a4ecc7f58f59e91d77a018d5d7ae42e2xayl.png'
            "
            alt="每日瑜伽专业瑜伽教学平台"
          />
        </div>
    </section>

    <!--第六屏幕-->
    <section class="section section-swiper">
      <div class="content clearfix relative">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <ul class="swiper clearfix">
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user1.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">虫子yogi</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    我属于微胖族，但是下班吃完晚饭懒得去健身房，自己在家瞎练也没有什么太大的效果，所以下载了这款软件。每日瑜伽里不仅有科学体系的减肥课程，每日提醒功能还能督促我每天练习。它是我手机里的健身减肥教练，大爱啊！
                  </p>
                </li>
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user2.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">静秋子（珍珠）</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    在应用市场里搜索瑜伽时看到「每日瑜伽」排在第一位，就下载使用了。在APP里大致看了一下，内容还挺丰富得，对于有减肥、塑形、瘦腿需求的人来说很实用。最重要的是里面有适合新人的入门瑜伽课程，对我这种没有任何瑜伽基础的人来说，还是相当不错的！希望我能持之以恒，坚持用「每日瑜伽」练习瑜伽。
                  </p>
                </li>
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user3.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">诗雨流星</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    其实早就下载这个软件用了，自己在家练瑜伽也很方便，APP里的课程成体系很全面。刚开始用的免费课程，有一次发现VIP课程限免，果断下载使用后发现非常棒，之后就成了每日瑜伽所有课程的忠实粉丝，必须给每日瑜伽好评，大赞！
                  </p>
                </li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul class="swiper clearfix">
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user4.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">兔子爱瑜伽</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    我给自己定了固定的每日瑜伽学习时间，每天跟着软件里的课程练习，缓解了不少关节上的不适。我会努力坚持下去的，先给这样的软件32个赞！希望后面上线更多有用的课程。
                  </p>
                </li>
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user5.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">小安的拉萨瑜伽时光</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    从来不写评论，这是第一次，最大的原因是真心喜欢这个软件，因为它很方便也很实用。每次发微信介绍它时就发现朋友圈很多人也在用，说明确实好。希望能多点时间更长，更重基础的课程。
                  </p>
                </li>
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user6.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">小马驹溜溜</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    我是做互联网的，每天的工作压力特别大，所以我经常选择通过运动来减轻压力。【每日瑜伽】里的课程非常适合我，每次练习里边的课程后，能感到确实起到了减压作用，非常棒！
                  </p>
                </li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul class="swiper clearfix">
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user7.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">行走的小语</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    由浅入深、由简入繁，这样的讲解易使初学者逐步坚持下来，也是我唯一坚持练习下来的瑜伽课程。非常感谢【每日瑜伽】的全体人员，希望以后多设计不同类别的计划用以循序渐进地进行练习，这样更容易坚持下来。
                  </p>
                </li>
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user8.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">幸福的葛葛</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    我个人还是很喜欢这款软件的，有很多不错的课程。我平时上班老坐着，一整天下来就浑身不舒服。自从用了每日瑜伽，下班后回家就可以练习。瑜伽也缓解了久坐带来的不适，超级赞！
                  </p>
                </li>
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user9.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">优雅心灵_1</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    健康生活从自律开始，自从坚持做瑜伽以来，觉得自己无论是身体状态还是意志力都提升了不少。我很喜欢这个软件，课程动作讲解到位，而且配合呼吸法也很适合我。
                  </p>
                </li>
              </ul>
            </div>
            <div class="swiper-slide">
              <ul class="swiper clearfix">
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user10.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">瑜时光xue</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    很好用，已经坚持练习一个月了，头痛减少了、肩背也轻松了。很喜欢新增加的“全身燃脂计划”，正在练习中，希望有更多更好的计划上线。
                  </p>
                </li>
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user11.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">玥呢</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    真的特别棒！因为我经常坐在电脑跟前，还经常低头玩手机，所以时常感觉肩颈特别不舒服。在【每日瑜伽】里练习瑜伽后感觉很好，尤其练习了“肩颈腰背修复”课程之后就更喜欢这里的课程了。
                  </p>
                </li>
                <li>
                  <div class="person clearfix">
                    <img
                      class="pull-left"
                      src="../assets/img/user12.jpg"
                      alt="每日瑜伽专业瑜伽教学平台"
                    />
                    <div class="pull-left">
                      <p class="name">halfmylove</p>
                      <div class="star">
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                        <i></i>
                      </div>
                    </div>
                  </div>
                  <p class="word">
                    如果有人和我一样天天坐着导致腰背的肌肉十分僵硬，那么一定要试试“舒展背部”这个课程！我练了一段时间感觉好多了，腰背肌肉舒松了许多，以后我一定会坚持练习！
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </section>

    <!--第七屏幕-->
    <section class="section part-center home-part7 relative">
      <div class="section-text">
        <img
          class="logo"
          src="../assets/img/down-logo.png"
          alt="每日瑜伽专业瑜伽教学平台"
        />
        <!-- <p class="description">
          全球5000万用户的共同选择，5000+瑜伽课程随心选择，专业导师精心编排，随时随地都能练习
          <br />支持iOS、安卓版本下载，TV端可前往各大电视应用市场下载
        </p> -->
      </div>

      <ul class="download clearfix">
        <li class="download-hover" style="margin-right: 100px">
          <div class="erweima ios hide-m">
            <img
              src="//qiniucdn.dailyyoga.com.cn/d6/2b/d62bbb7a3c2db86f29b469a20ff49b5e.png"
              alt="每日瑜伽专业瑜伽教学平台"
            />
          </div>
          <a
            @click="qrCode('iOS')"
            class="pull-left download-new ios-download"
            href="javascript:;"
          ></a>
        </li>

        <li class="download-hover">
          <div class="erweima and hide-m">
            <img
              src="//qiniucdn.dailyyoga.com.cn/d6/2b/d62bbb7a3c2db86f29b469a20ff49b5e.png"
              alt="每日瑜伽专业瑜伽教学平台"
            />
          </div>
          <a
            @click="qrCode('And')"
            class="pull-left download-new ad-download-white"
            href="javascript:;"
          ></a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import Swiper from '../assets/js/swiper-3.4.2.min.js';
import DY from '../assets/js/common';
import { reportPageViewEvent, reportClickEvent } from '../assets/js/saInstance';
import qs from 'qs';

export default {
  name: 'index',

  beforeCreate() {
    document.title = '每日瑜伽-全球瑜伽健身和文化品牌';
    $("meta[name='keywords']").attr(
      'content',
      '每日瑜伽官网,每日瑜伽,瑜伽教学,瑜伽视频,瑜伽减肥视频,瑜伽课程,瑜伽视频教程初级,瑜伽入门,瑜伽初学者,瑜伽初学者视频,瘦身瑜伽',
    );
    $("meta[name='description']").attr(
      'content',
      '每日瑜伽是一家同时拥有线上课程、瑜伽电商、垂直社群和线下教学业务的综合瑜伽服务平台，致力于为用户提供专业的线上线下多场景瑜伽服务，打造全球专业的瑜伽健身与文化品牌，促进全球瑜伽文化交流、发展和规范。',
    );

    //获取banner
    this.$axios
      .get(DY.baseUrl + 'common/banner_conf?item=home')
      .then((rsp) => {
        if (rsp.data.error_code == 0) {
          this.banner = rsp.data.result;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    //获取媒体报道列表
    this.$axios.get(DY.baseUrl + 'common/news').then((rsp) => {
      if (rsp.data.error_code == 0) {
        this.listIndex = rsp.data.result.news[0].id;
      }
    });
  },

  data() {
    return {
      banner: {},
      downIos: 0,
      downAnd: 0,
      listIndex: '',
      isMobileImg: $('body').width() < 1024,
      mobileImgQ: '?imageMogr2/thumbnail/!50p',
    };
  },

  methods: {
    qrCode(type) {
      if (DY.isMobile) {
        window.open(DY.downloadUrl);
        return;
      }
    },

    playVideo(video, img, btn) {
      var dom = $('#' + video)[0];
      $('#' + img).hide();

      if (dom.paused) {
        $('.video').addClass('active');
        reportClickEvent({
          click_id: 269,
          page_id: 206,
        });
        dom.play();
        $('#' + btn).hide();
        return;
      }

      $('.video').removeClass('active');
      $('#' + btn).show();
      dom.pause();
    },

    goRYT() {
      window.open('http://www.yogau.cn/');
    },

    download(type) {
      if (DY.isMobile) {
        window.open(DY.downloadUrl);
        return;
      }
    },
  },

  mounted() {
    reportPageViewEvent({
      page_id: 206,
      pageinfo: location.href,
    });

    new Swiper('.swiper-container', {
      autoplay: 5000,
      pagination: '.swiper-pagination',
      paginationClickable: true,
      loop: true,
    });

    if (!DY.isMobile) {
      $('#banner-home').height($(window).height() + 'px');
    }
  },
};
</script>

<style lang="scss">
.home-part7 .download a.download-new,
.download .download-new {
  width: 150px;
  background-size: 100% 100%;
  height: 50px;
  border: none;
  &.ios-download {
    background-image: url('http://qiniucdn.dailyyoga.com.cn/3e/78/3e7886766e9eccb1e9b8596e3919002f.png');
  }
  &.ad-download {
    background-image: url('http://qiniucdn.dailyyoga.com.cn/0d/41/0d41ea8468cb900c298d9c755bacb5d6.png');
  }
  &.ad-download-white {
    background-image: url('http://qiniucdn.dailyyoga.com.cn/e1/69/e169c339208d57f734c9619ce63cbd6a.png');
  }
  &.tv-download {
    background-image: url('http://qiniucdn.dailyyoga.com.cn/0a/90/0a90fcd79361f8f5886a27a554550b9f.png');
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue